<div class="flex flex-col gap-4">
  <h5 class="text-xl">{{ myTranslation("officeAddin.changesInTimeFrame") }}</h5>

  <p-floatLabel variant="in">
    <p-calendar
      [(ngModel)]="myDate"
      selectionMode="range"
      dateFormat="dd.mm.yy"
      (click)="resetInvalidDateState()"
    ></p-calendar>
    <label [class]="dateSelectorState">{{ myTranslation("officeAddin.timeFrame") }}</label>
  </p-floatLabel>
  <new-ui-button label="{{ myTranslation('officeAddin.importChanges') }}" (click)="getData()"></new-ui-button>
</div>
